import { START_LOADING, END_LOADING, FETCH_ALL, FETCH, CREATE, UPDATE, DELETE, REWARD, FETCH_BY_ID, FETCH_WITH_QUERY} from '../constants/actionTypes';

const initialState = {
    reward:[],
    isLoading: false,
    selectedReward:'',
};

const rewardReducer = (state = initialState, action) => {
    if(action?.payload?.type === REWARD ){
        switch (action.type) {
          case START_LOADING:
            return { ...state, isLoading: true };
          case END_LOADING:
            return { ...state, isLoading: false };
          case FETCH:
          case FETCH_WITH_QUERY:
            return { ...state, reward: action.payload.data };
          case FETCH_BY_ID:
            return { ...state, selectedReward: action.payload.data };
          case FETCH_ALL:
            return { ...state, reward: action.payload.data };
          case CREATE:
              return {...state, reward: {...state.reward, rewards: [...state.reward.rewards, action.payload.data]} };
          case UPDATE:
              return {...state, reward: {rewards:state.reward.rewards.map((reward) => reward._id === action.payload.data._id? {...reward, ...action.payload.data}: reward)}};
          case DELETE:
            return {
              ...state,
              reward: {
                ...state.reward,
                rewards: state.reward.rewards.filter(reward =>
                  Array.isArray(action.payload.data._id)
                    ? !action.payload.data._id.includes(reward._id)
                    : reward._id !== action.payload.data._id
                ),
                pagination: {
                  ...state.reward.pagination,
                  total: Array.isArray(action.payload.data._id)
                    ? state.reward.pagination.total - action.payload.data._id.length
                    : state.reward.pagination.total - 1
                }
              }
            };

          default:
            return state;
        }
    }
    else{
        return state;
    }
  };
export default rewardReducer;